import React from "react";

const ProductInventoryCard = ({ product }) => {
    return (
        <div className="card mb-4">
            <div className="card-header">
                <h5 className="mb-0"> INVENTORY</h5>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-3">
                        <strong>Weight:</strong> {product.weight || '-'} {product.dimensions_unit || ''}
                    </div>
                    <div className="col-md-3">
                        <strong>Length:</strong> {product.length || '-'} {product.dimensions_unit || ''}
                    </div>
                    <div className="col-md-3">
                        <strong>Width:</strong> {product.width || '-'} {product.dimensions_unit || ''}
                    </div>
                    <div className="col-md-3">
                        <strong>Height:</strong> {product.height || '-'} {product.dimensions_unit || ''}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Material:</strong> {product.material || '-'}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Color:</strong> {product.color || '-'}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Size:</strong> {product.size || '-'}
                    </div>
                    <div className="col-md-3 mt-2">
                        <strong>Country of Origin:</strong> {product.country_of_origin || '-'}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductInventoryCard;